import { getCsrfToken } from "../auth/authApi";
import { apiFetch } from "../../shared/http/apiFetch";

export type CommercialRecord = Record<string, unknown> & {
  id: string;
  code?: string;
  number?: string;
  name?: string;
  status?: string;
  isActive?: boolean;
  total?: number;
};
export type Reference = { id: string; code: string; name: string };
export type CommercialSnapshot = Record<string, unknown> & {
  companyName: string;
  overview: Record<string, number>;
  articles: Reference[];
  units: Reference[];
  warehouses: Reference[];
};
export async function getCommercial(module: "sales" | "purchasing") {
  const response = await apiFetch(`/api/v1/${module}`, {
    credentials: "include",
  });
  if (!response.ok) throw new Error("commercial.loadError");
  return response.json() as Promise<CommercialSnapshot>;
}
export async function saveCommercial(
  module: "sales" | "purchasing",
  entity: string,
  id: string | undefined,
  body: unknown,
) {
  const response = await apiFetch(
    `/api/v1/${module}/${entity}${id ? `/${id}` : ""}`,
    {
      method: id ? "PUT" : "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": await getCsrfToken(),
      },
      body: JSON.stringify(body),
    },
  );
  const payload = (await response.json().catch(() => null)) as {
    code?: string;
  } | null;
  if (!response.ok) throw new Error(payload?.code ?? "commercial.saveError");
  return payload;
}
export async function changeCommercialStatus(
  module: "sales" | "purchasing",
  entity: string,
  id: string,
  status: string,
) {
  const response = await apiFetch(
    `/api/v1/${module}/${entity}/${id}/status/${status}`,
    {
      method: "PUT",
      credentials: "include",
      headers: { "X-CSRF-TOKEN": await getCsrfToken() },
    },
  );
  if (!response.ok) throw new Error("commercial.saveError");
}
export async function convertSalesQuotation(id: string) {
  const response = await apiFetch(`/api/v1/sales/quotations/${id}/convert`, {
    method: "POST",
    credentials: "include",
    headers: { "X-CSRF-TOKEN": await getCsrfToken() },
  });
  const payload = (await response.json().catch(() => null)) as {
    code?: string;
    id?: string;
  } | null;
  if (!response.ok) throw new Error(payload?.code ?? "commercial.saveError");
  return payload;
}
export async function convertPurchasingQuotation(id: string) {
  const response = await apiFetch(`/api/v1/purchasing/quotations/${id}/convert`, {
    method: "POST",
    credentials: "include",
    headers: { "X-CSRF-TOKEN": await getCsrfToken() },
  });
  const payload = (await response.json().catch(() => null)) as {
    code?: string;
    id?: string;
  } | null;
  if (!response.ok) throw new Error(payload?.code ?? "commercial.saveError");
  return payload;
}
export function salesDocumentUrl(entity: string, id: string) {
  return `/api/v1/sales/documents/${entity}/${id}.pdf`;
}
export function purchasingDocumentUrl(entity: string, id: string) {
  return `/api/v1/purchasing/documents/${entity}/${id}.pdf`;
}
export async function sendSalesDocument(
  entity: string,
  id: string,
  recipient: string,
  subject?: string,
  message?: string,
) {
  const response = await apiFetch(
    `/api/v1/sales/documents/${entity}/${id}/send`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": await getCsrfToken(),
      },
      body: JSON.stringify({ recipient, subject, message }),
    },
  );
  const payload = (await response.json().catch(() => null)) as {
    code?: string;
  } | null;
  if (!response.ok)
    throw new Error(payload?.code ?? "sales.documentSendFailed");
  return payload;
}
export async function sendPurchasingDocument(
  entity: string,id: string,recipient: string,subject?: string,message?: string,
) {
  const response=await apiFetch(`/api/v1/purchasing/documents/${entity}/${id}/send`,{method:"POST",credentials:"include",headers:{"Content-Type":"application/json","X-CSRF-TOKEN":await getCsrfToken()},body:JSON.stringify({recipient,subject,message})});
  const payload=(await response.json().catch(()=>null)) as {code?:string}|null;
  if(!response.ok)throw new Error(payload?.code??"purchasing.documentSendFailed");
  return payload;
}
